module.exports = __webpack_public_path__ + "img/Artistic-Gymnastics.d02525c7.png";